/** Frontend model for one admin feedback row, with parsed dates. */
export interface AdminFeedbackEntry {
  id: string;
  instructorId: string;
  /** Who wrote it: an instructor, or a member of that instructor's organization (US-99). */
  audience: "Instructor" | "Member";
  memberId: string | null;
  firstName: string;
  lastName: string;
  email: string;
  type: string;
  message: string;
  dateCreated: Date;
}

/** Full sender name, falling back to the email, then to a placeholder. */
export const adminFeedbackSenderName = (entry: AdminFeedbackEntry): string => {
  const name = `${entry.firstName} ${entry.lastName}`.trim();
  if (name.length > 0) return name;
  return entry.email.length > 0 ? entry.email : "Deleted account";
};
